(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3Alert', {
            templateUrl: 'app/shared/modals/alert.component.html',
            controller: AlertComponent,
            bindings: {
                close: '&',
                resolve: '<'
            }
        });

    AlertComponent.$inject = ['alertType'];
    function AlertComponent(alertType) {
        var ctrl = this;
        ctrl.$onInit = init;
        ctrl.getClass = getClass;

        function init() {
            ctrl.message = ctrl.resolve.message;
            ctrl.type = ctrl.resolve.type;
        }

        function getClass() {
            switch (ctrl.type) {
                case alertType.Warn: return "text-warning fa-exclamation-triangle";
                case alertType.Info: return "text-info fa-info-circle";
                case alertType.Success: return "text-success fa-check-circle";
                default: return "text-danger fa-times-circle";
            }
        }
    }
})();